import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import AdminLayout from './pages/AdminLayout';
import MusteriTakip from './pages/MusteriTakip';
import UstaGiris from './pages/UstaGiris';
import UstaPanel from './pages/UstaPanel';

export default function App() {
  useEffect(() => {
    const link = document.querySelector('#pwa-manifest');
    if (link) {
      if (window.location.pathname.startsWith('/usta')) {
        link.href = '/manifest-usta.json';
      } else {
        link.href = '/manifest-admin.json';
      }
    }
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Login / Giriş */}
          <Route path="/giris" element={<Login />} />

          {/* Admin Paneli ve Tüm Alt Rotaları */}
          <Route path="/admin/*" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          } />

          {/* Usta Paneli */}
          <Route path="/usta/giris" element={<UstaGiris />} />
          <Route path="/usta/panel" element={<UstaPanel />} />

          {/* Müşteri Takip Sayfası (Public) */}
          <Route path="/takip/:musteriId" element={<MusteriTakip />} />

          {/* Redirects */}
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}